import {
  Snackbar as MuiSnackbar,
  Alert,
  AlertColor,
  SnackbarProps as MuiSnackbarProps,
} from '@mui/material';

interface SnackbarProps extends Omit<MuiSnackbarProps, 'onClose'> {
  message: string;
  severity?: AlertColor;
  onClose: () => void;
}

export function Snackbar({
  message,
  severity = 'info',
  onClose,
  ...props
}: SnackbarProps) {
  return (
    <MuiSnackbar
      open={props.open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      {...props}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </MuiSnackbar>
  );
}
